import React from 'react';

import { ChildrenPropType } from 'src/utils/types';
import { LayoutHeader, LayoutHeaderProps } from 'src/components/common/LayoutHeader';

type Props = {
  children: ChildrenPropType;

  show?: boolean;
} & LayoutHeaderProps;

export const LayoutWithHeader: React.FC<Props> = ({ children, show, ...headerProps }) => {
  if (show === false) {
    return <>{children}</>;
  }

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <LayoutHeader {...headerProps} />
      <div className="row account-management-page-body">
        <div className="col-md-12" id="account-management-page-content">
          {children}
        </div>
      </div>
    </>
  );
};
